import type { CustomIconProps } from '../types';

const Star = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fill="#414042"
            fillRule="evenodd"
            d="M7.669 4.218 6 0 4.331 4.218 0 4.584l3.3 2.972L2.292 12 6 9.618 9.708 12 8.7 7.556 12 4.584l-4.331-.366Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Star;
